export const validateNotEmpty = (value) => {
  return value!== null && value!== undefined && value.toString().trim()!== '';
};

export const validatePhoneNumber = (value) => {
  const phoneRegex = /^1[0-9]{10}$/;
  return phoneRegex.test(value);
};